const ENTITY_TYPES = {
    Field: 'Field',
    Farm: 'Farm',
    Customer: 'Customer',
    Retailer: 'Retailer',
    // ORGANIZATION: 'Organization',
};

export default ENTITY_TYPES;